export default class Location {
  lat = undefined
  lng = undefined
  address = undefined
  city = undefined

  constructor (source = undefined) {
    this.raw = source
    if(source) {
      this.parseSource(source)
    }
  }

  parseSource (source) {
    for (const prop in source) {
      if(prop in this) {
        this[prop] = source[prop]
      }
    }
  }

  isValid () {
    return this.lat && this.lng && this.address && this.city
  }

}
